import { getPrototypeOf } from '../shortcut'

import type { TRecord } from '../types'

export function isInheritProto(childProto: TRecord, parentProto: TRecord) {
  if (
    typeof childProto !== 'object' ||
    typeof parentProto !== 'object' ||
    childProto === null ||
    parentProto === null
  ) {
    return false
  }
  let proto = childProto
  while (proto) {
    if (proto === parentProto) return true
    proto = getPrototypeOf(proto)
  }
  return false
}
